import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation  } from 'react-router-dom';

import Login from './login.js';
import ChatbotMessage from './notAuthorized.js';

import { detectMode } from '../../services/networkMode.js';

import { validateToken } from '../../API/server/validateToken.js';
import { cmdApi, setNodeRedBaseURL } from '../../services/axios.js';

const LoginWrapper = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [mode, setMode] = useState(null);
  const [loadingOnline, setLoadingOnline] = useState(false);
  const [error, setError] = useState(null);

  // pega params da URL (caso seja callback do login)
  const searchParams = new URLSearchParams(location.search);
  const token = searchParams.get('token');
  const condominioId =
    searchParams.get('condominio_id') || searchParams.get('condominio');

  // 1) Descobrir se é online ou offline
  useEffect(() => {
    async function checkMode() {
      const currentMode = await detectMode();
      setMode(currentMode);
    }

    checkMode();
  }, []);

  // 2) Finalizar login ONLINE quando tiver token + condominio na URL
  useEffect(() => {
    // só faz sentido tentar isso se estiver online
    if (mode !== 'online') return;

    // se não veio token/condominio na URL, deixa quieto.
    // o usuário vai ver o ChatbotMessage com o link pro login.
    if (!token || !condominioId) return;

  async function finishOnlineLogin() {
    try {
      setLoadingOnline(true);
      setError(null);

      // 1) valida o token (monta sessão + salva user + expirationTime)
      await validateToken(token);

      // 2) busca a URL do Node-RED pra esse condomínio
      const { data } = await cmdApi.get(`/condominios/${condominioId}`);
      const serverUrl = data?.condominio?.server_url;
        
      if (!serverUrl) {
        throw new Error('server_url não retornado pelo CMD_SERVER.');
      }

      // 3) Configura o Node-RED pra usar essa URL online
      let normalizedServerUrl = serverUrl;
      if (!/^https?:\/\//.test(normalizedServerUrl)) {
        normalizedServerUrl = `http://${normalizedServerUrl}`;
      }

      setNodeRedBaseURL(normalizedServerUrl);

      sessionStorage.setItem('nodeRedOnlineUrl', normalizedServerUrl);
      sessionStorage.setItem('nodeRedMode', 'online');
      sessionStorage.setItem('hasEverBeenOnline', 'true');

      // 4) Manda pra home (PrivateRoute checa loggedIn + expirationTime)
      navigate('/home', { replace: true });
    } catch (err) {
      console.error('Erro no login online:', err?.response?.data || err);
      setError(
        err?.response?.data?.error ||
          err?.message ||
          'Não foi possível completar o login online. Tente novamente.'
      );
    } finally {
      setLoadingOnline(false);
    }
  }
    finishOnlineLogin();
  }, [mode, token, condominioId, navigate]);

  // --------- RENDER ---------

  // ainda detectando o modo
  if (!mode) {
    return (
      <div style={{ textAlign: 'center', marginTop: '2rem', color: '#fff' }}>
        Detectando ambiente...
      </div>
    );
  }

  // MODO OFFLINE → login local como já era
  if (mode === 'offline') {
    return <Login navigate={navigate} />;
  }

  // MODO ONLINE
  // Se estamos processando token de callback:
  if (token && condominioId) {
    if (loadingOnline) {
      return (
        <div style={{ textAlign: 'center', marginTop: '2rem', color: '#fff' }}>
          Autenticando no modo online...
        </div>
      );
    }

    if (error) {
      return (
        <div style={{ textAlign: 'center', marginTop: '2rem', color: '#fff' }}>
          <p>{error}</p>
          <button onClick={() => window.location.href = '/login'}>
            Voltar para o login
          </button>
        </div>
      );
    }

    // teoricamente não chega aqui porque o navigate('/home') acontece
    return null;
  }

  // ONLINE e sem token na URL → mostra mensagem padrão com link pro login externo
  return <ChatbotMessage />;
};

export default LoginWrapper;